import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { TID } from "@/constants/testIds";

const LOGO_URL = "/logo.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@premiercleaning.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md card-surface rounded-2xl p-10">
        <div className="flex justify-center mb-6">
          <img src={LOGO_URL} alt="Premier Cleaning" className="h-16 w-16 object-contain" />
        </div>
        <div className="text-center">
          <div className="overline text-[#D4AF37]">Admin Portal</div>
          <h1 className="font-serif-display text-3xl text-white mt-2">Sign In</h1>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-7">
          <div>
            <label className="overline text-white/50 block mb-2">Email</label>
            <input
              type="email"
              className="input-line"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid={TID.adminLoginEmail}
              required
            />
          </div>
          <div>
            <label className="overline text-white/50 block mb-2">Password</label>
            <input
              type="password"
              className="input-line"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid={TID.adminLoginPassword}
              required
            />
          </div>
          {error && <div className="text-sm text-red-400">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid={TID.adminLoginSubmit}
            className="btn-gold w-full justify-center"
          >
            {loading ? <Loader2 className="animate-spin" size={18}/> : <><Lock size={16} /> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
